var map = {
	"./1.webp": 1316,
	"./IMG_5350-min.webp": 1125,
	"./IMG_5354-min.webp": 2217,
	"./f85f1c0c-20c5-43cc-9009-8ef2c7d4671e-min.webp": 4763,
	"./x.webp": 7551,
	"./xx.webp": 8001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8385;